import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SitesBuilderGuard } from '../guards/sites-builder.guard';
import {
  FlowSitesListResolver,
  FlowListResolver,
  FlowInfoResolver,
  FlowSiteMasterFileResolver,
} from '../resolvers/sites-builder.resolver';
import { SbEditorComponent } from './sb-editor/sb-editor.component';
import { SbListComponent } from './sb-list/sb-list.component';
import { SbWorkflowsComponent } from './sb-workflows/sb-workflows.component';

const routes: Routes = [
  /*   {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full'
  }, */
  {
    path: '',
    canActivate: [SitesBuilderGuard],
    children: [
      {
        path: 'list',
        component: SbListComponent,
        resolve: {
          flow: FlowSitesListResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      {
        path: 'workflows',
        component: SbWorkflowsComponent,
        resolve: {
          flows: FlowListResolver,
        },
      },
      {
        path: 'editor/:workflowId',
        component: SbEditorComponent,
        resolve: {
          dataFlow: FlowInfoResolver,
        },
      },
      {
        path: 'editor/:workflowId/:siteId',
        component: SbEditorComponent,
        resolve: {
          dataFlow: FlowInfoResolver,
          site: FlowSiteMasterFileResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SbManagerRoutingModule {}
